import { Breadcrumb, Upload, Typography, Modal, Row, Col, Button, Space, Radio, Card, Input, Select, Checkbox, DatePicker, message, TreeSelect, Form } from 'antd';
import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { ExclamationCircleOutlined, PlusOutlined } from '@ant-design/icons';
import axios from 'axios';
import dayjs from 'dayjs';
// import AdminModal from './AdminModal';
const { Title, Paragraph, Text, Link } = Typography;
const { confirm } = Modal;
const { TextArea } = Input;
const DepartmentRole = ({
    field,
    remove,
    defaultDepartment,
    defaultRole,
    onDepartmentChanged = () => { }, onRoleChanged = () => { }
}) => {

    const [departmentData, setDepartmentData] = useState([]);
    const [roleData, setRoleData] = useState([]);
    const [departmentDefaultId, setDepartmentDefaultId] = useState(defaultDepartment);
    const [departmentId, setDepartmentId] = useState(defaultDepartment);
    const [roleId, setRoleId] = useState(null);

    const getDepartmentData = () => {
        axios
            .get('/organization_structure/api/department', {
                params: {
                    classify_structure_type_id: 0
                }
            })
            .then((response) => {
                setDepartmentData(response.data.data)
            })
    }
    useEffect(() => {
        getDepartmentData()
    }, []);
    useEffect(() => {
        if (departmentData.length !== 0 && defaultDepartment) {
            console.log(departmentData)
            setDepartmentId(defaultDepartment)
        }
    }, [departmentData]);
    useEffect(() => {
        console.log(departmentId)
        setRoleData([])
        setRoleId(null)
        if (departmentId === departmentDefaultId && departmentId && defaultRole) {
            setRoleId(defaultRole)
            setDepartmentDefaultId(null)
        }

        if (departmentId) {
            axios
                .get('/organization_structure/api/role', {
                    params: {
                        classify_structure_type_id_for_department: departmentId,
                        classify_structure_type_id: 0

                    }
                })
                .then((response) => {
                    setRoleData(response.data.data)
                })
        }
    }, [departmentId]);

    return (

        <Row gutter={[4, 4]} justify={""}>
            <Col span={6}>
                <Button
                    onClick={() => {
                        confirm({
                            title: '確定要刪除嗎',
                            icon: <ExclamationCircleOutlined />,
                            okText: '確定',
                            okType: 'primary',
                            cancelText: '取消',
                            onOk() {
                                remove(field.name);
                            },
                            centered: true
                        });
                    }}> 刪除
                </Button>
            </Col>
            <Col span={24}>
                {departmentData.length !== 0 && <>
                    <Form.Item
                        label={"部門"}
                        name={[field.name, 'department_classify_structure_type_id']}
                        rules={[
                            {
                                required: true,
                                message: `此為必填項目`
                            }
                        ]}

                    >
                        <TreeSelect
                            defaultValue={
                                departmentId
                            }
                            showSearch
                            style={{
                                width: '100%',
                            }}
                            // value={value}
                            dropdownStyle={{
                                maxHeight: 400,
                                overflow: 'auto',
                            }}
                            placeholder="選擇部門"
                            allowClear
                            treeDefaultExpandAll
                            treeNodeFilterProp={"title"}
                            onChange={
                                (e) => {
                                    setDepartmentId(e)
                                    // onChangeDepartmentId(e)
                                }
                            }
                            treeData={departmentData}
                        />
                    </Form.Item>
                </>}
                {departmentId && roleData.length !== 0 && <Form.Item

                    label={"職稱"}
                    name={[field.name, 'role_classify_structure_type_id']}
                    rules={[
                        {
                            required: true,
                            message: `此為必填項目`
                        }
                    ]}
                >
                    <TreeSelect
                        defaultValue={
                            roleId
                        }
                        showSearch
                        style={{
                            width: '100%',
                        }}
                        dropdownStyle={{
                            maxHeight: 400,
                            overflow: 'auto',
                        }}
                        placeholder="選擇職稱"
                        allowClear
                        treeDefaultExpandAll
                        treeNodeFilterProp={"title"}
                        onChange={
                            (e) => setRoleId(e)
                        }
                        treeData={roleData}
                    />
                </Form.Item>
                }
            </Col>
        </Row>

    )
}
export default DepartmentRole;

